import { TFunction } from 'i18next';
import { VALIDATION } from '../constants';
import { validateMaxLength } from './validateMaxLength';
import { validatePattern } from './validatePattern';
import { validateMinLength } from './validateMinLength';

export function validateShortName(t: TFunction) {
	return {
		...validatePattern(
			VALIDATION.shortName.pattern,
			t('invalid_symbols', {
				allowedSymbols: 'letters A-Z, upper-lower cases, integ. 0-9',
			}),
		),
		...validateMaxLength(
			VALIDATION.shortName.maxLength,
			t('short_name_too_long'),
		),
		...validateMinLength(
			VALIDATION.shortName.minLength,
			t('short_name_too_short'),
		),
	};
}
